import * as React from 'react';
import { ISurveyAdminSummary } from '../../models';

export interface ISurveyAdminSummaryLoaderProps {
	surveyId: number;
	surveyAdminSummary?: ISurveyAdminSummary;
	GetSurveyAdminSummary: (surveyId: number) => void;
}

export class SurveyAdminSummaryLoader extends React.Component<ISurveyAdminSummaryLoaderProps> {
	public componentDidMount() {
		if (this.props.surveyAdminSummary === undefined || this.props.surveyAdminSummary.surveyId !== this.props.surveyId) {
			this.props.GetSurveyAdminSummary(this.props.surveyId);
		}
	}

	public render() {
		return <></>;
	}
}
